import Vue from "vue";
// import CKEditor from 'ckeditor4-vue';
import CKEditor from '@ckeditor/ckeditor5-vue';

Vue.use(CKEditor);
